import { Icon } from "@chakra-ui/react";
import React from "react";
import {
  getTwoToneChakraColors,
  TwoToneIconProps,
} from "./getTwoToneChakraColors";

export function SiFifo({
  colorScheme = "primary",
  primaryShade = 600,
  secondaryShade = 200,
  ...props
}: TwoToneIconProps) {
  const { primaryColor, secondaryColor } = getTwoToneChakraColors({
    colorScheme,
    primaryShade,
    secondaryShade,
  });

  return (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
      <line
        x1="19.9994"
        y1="16"
        x2="5.99939"
        y2="16"
        stroke={secondaryColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M20.1 8.8999L26.1647 14.8721C26.6812 15.3807 26.6876 16.2118 26.1788 16.7283L20.1 22.8999"
        stroke={primaryColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
}
